export const ChatBackground = () => (
  <div className="absolute inset-0 pointer-events-none overflow-hidden">
    <svg width="100%" role="presentation" height="100%" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <pattern id="kawaii-pattern-light" patternUnits="userSpaceOnUse" width="82" height="80">
          {/* Pastel Pink Hearts */}
          <path
            d="M25,27
               C25,22 32,20 35,26
               C38,20 45,22 45,27
               C45,34 35,40 35,40
               C35,40 25,34 25,27Z"
            fill="#FFC1E0" // pastel pink
            opacity="0.22"
          />
          <path
            d="M65,67
               C65,63 70,61 73,66
               C76,61 81,63 81,67
               C81,73 73,77 73,77
               C73,77 65,73 65,67Z"
            fill="#FFC1E0"
            opacity="0.2"
          />
        </pattern>

        <pattern id="kawaii-pattern-dark" patternUnits="userSpaceOnUse" width="82" height="80">
          {/* Soft Purple Hearts */}
          <path
            d="M25,27
               C25,22 32,20 35,26
               C38,20 45,22 45,27
               C45,34 35,40 35,40
               C35,40 25,34 25,27Z"
            fill="#B69CD9" // soft purple
            opacity="0.18"
          />
          <path
            d="M65,67
               C65,63 70,61 73,66
               C76,61 81,63 81,67
               C81,73 73,77 73,77
               C73,77 65,73 65,67Z"
            fill="#B69CD9"
            opacity="0.15"
          />
        </pattern>

        <linearGradient id="kawaii-gradient-light" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#FFF5FB" /> {/* Super light pink */}
          <stop offset="100%" stopColor="#FCEAEF" />
        </linearGradient>
        <linearGradient id="kawaii-gradient-dark" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#222235" />
          <stop offset="100%" stopColor="#331834" />
        </linearGradient>
      </defs>
      <rect width="100%" height="100%" fill="url(#kawaii-gradient-light)" className="dark:hidden" />
      <rect
        width="100%"
        height="100%"
        fill="url(#kawaii-gradient-dark)"
        className="hidden dark:block"
      />
      <rect
        width="100%"
        height="100%"
        fill="url(#kawaii-pattern-light)"
        className="dark:hidden"
        opacity="0.3"
      />
      <rect
        width="100%"
        height="100%"
        fill="url(#kawaii-pattern-dark)"
        className="hidden dark:block"
        opacity="0.25"
      />
    </svg>
  </div>
);
